/** An Element Close Event */
export default class Close extends CustomEvent {
    constructor(caller) {
        super('close', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
